import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import PlanCreator from "@components/PlanCreator/PlanCreator";
import { PlanCreatorProvider } from "@components/PlanCreator/PlanCreatorContext";
import { MODALS_ENUM } from "@constants/Modals";
import { IDaySchedule, IMiningPlanOptions } from "@services/getMinerList";
import { MiningPlanParamsI } from "@services/miningRate";
import { useRef } from "react";
import styles from "./CreateRateModal.module.scss";

export interface CreatePlanModalProps extends CommonModalPropsI {
  beforeSave(data: MiningPlanParamsI): void;
  onResult(data: IDaySchedule[]): void;
  mining_plan?: IMiningPlanOptions;
}

function CreatePlanModal({
  mining_plan,
  formatMessage,
  ...props
}: CreatePlanModalProps) {

  // const isMobile = useMediaQuery("max", 525);
  const ref = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (ref.current && ref.current.parentElement) {
  //     ref.current.parentElement.style.width = isMobile ? "400px" : "500px";
  //   }
  // }, [ref]);

  const title = () => {
    if (!mining_plan) return formatMessage({ id: "modal.create_plan.title" });
    if (mining_plan.name === "default")
      return formatMessage({ id: "selector.plan.default" });
    return mining_plan.name;
  };

  return (
    <div className={styles.wrapper} ref={ref}>
      <Title>{title()}</Title>
      <PlanCreatorProvider
        value={{
          isAllowSkipBefore: true,
          isAllowAdd: true,
          reset: 0,
          plan: {
            id: 0,
            name: "",
            schedule: [],
            meta: ""
          },
          disabled: false,
          beforePost: props.beforeSave,
          afterSave: props.onResult,
        }}
      >
        <PlanCreator
          closeOnEsc={false}
          showTemplates={true}
          direction='vertical'
        />
      </PlanCreatorProvider>
    </div>
  );
}

export default WithModal(MODALS_ENUM.CREATE_PLAN_MODAL, CreatePlanModal);
